import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { RoutingService } from '../../services/routing.service';
import { LoginService } from '../../login/services/login.service';

/**
 * Component for updating the user's password.
 */
@Component({
	selector: 'password-reset',
	templateUrl: './password-reset.component.html',
	styleUrl: './password-reset.component.css'
})
export class PasswordResetComponent implements OnInit {
	LOCALIZATION: any;

	input = {
		username: '',
		newpass: '',
		newpassConfirm: ''
	};

	resetKey!: string;
	validlink: boolean = false;
	showPolicy: boolean = false;
	errorMsg: string | undefined = undefined;

	popoverHTML!: SafeHtml;
	validPass: boolean = false;

	constructor(
		private sanitizer: DomSanitizer,
		private userService: UserService,
		private alertsService: AlertsService,
		private loginService: LoginService,
		private routingService: RoutingService
	) {
	}

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;

		this.resetKey = this.routingService.getQueryParam('key') || '';
		this.getStatus();
	}

	private getStatus(): void {
		this.userService.getRequestStatus(this.resetKey).then(
			(expired: boolean) => {
				if (expired) {
					this.validlink = false;
					this.errorMsg = "Invalid or expired password reset link.";
				} else {
					this.validlink = true;
				}
			},
			(err: any) => {
				console.error("Could not get reset key status", err);
				this.validlink = false;
				this.errorMsg = err;
			}
		);
	}

	private createValidationResponse(): void {
		let html = this.loginService.getValidationResponse(this.validPass);
		this.popoverHTML = this.sanitizer.bypassSecurityTrustHtml(html);
	}

	validatePassword(): string {
		this.validPass = this.loginService.passwordValidate(this.input.newpass);
		this.createValidationResponse();
		return this.loginService.getValidationErrors();
	}

	setPassword(): void {
		if (this.input.newpass != this.input.newpassConfirm) {
			this.alertsService.error({
				message: this.LOCALIZATION.fillAllFields,
				delay: 5000
			});
			return;
		}

		let validationErrors = this.validatePassword();
		if (!this.validPass) {
			this.alertsService.error({
				message: this.LOCALIZATION.loginPasswordNoValidation + "\n" + validationErrors,
				delay: 5000
			});
			return;
		}

		this.userService.setNewPassword(this.input.username, this.input.newpass, this.resetKey).then(
			() => {
				this.input.newpass = '';
				this.alertsService.success({
					title: "Password Reset",
					message: "Password set. Please log in.",
					delay: 5000
				});

				this.userService.broadcastEvent.emit("dismissLoginModal");
				this.userService.goHome();
			},
			(err: any) => {
				console.error("Failed to update password", err);
				this.alertsService.error({
					title: "Password Reset Failed",
					message: err,
					delay: 5000
				});
			}
		);
	}
}
